// Pure form validators ported from legacy src/scripts/pages/auth.js.
// Format only — username uniqueness is enforced by authService.signUp (throws UsernameTaken).

export interface SignUpValues {
  fullName: string;
  username: string;
  email: string;
  password: string;
  confirmPassword: string;
  agree: boolean;
}

export interface SignInValues {
  identifier: string;
  password: string;
}

/** Field name → error message. Absent key = no error. */
export type FieldErrors = Partial<Record<string, string>>;

const USERNAME_RE = /^[a-zA-Z0-9_]{3,20}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateSignUp(v: SignUpValues): FieldErrors {
  const e: FieldErrors = {};
  if (!v.fullName.trim()) e.fullName = 'Full name is required.';
  if (!v.username.trim()) e.username = 'Username is required.';
  else if (!USERNAME_RE.test(v.username.trim()))
    e.username = 'Username must be 3–20 characters: letters, digits, or underscore.';
  if (!v.email.trim()) e.email = 'Email is required.';
  else if (!EMAIL_RE.test(v.email.trim())) e.email = 'Enter a valid email address.';
  if (!v.password) e.password = 'Password is required.';
  else if (v.password.length < 8) e.password = 'Password must be at least 8 characters.';
  if (!v.confirmPassword) e.confirmPassword = 'Please confirm your password.';
  else if (v.confirmPassword !== v.password) e.confirmPassword = 'Passwords do not match.';
  if (!v.agree) e.agree = 'You must agree to the Terms to continue.';
  return e;
}

export function validateSignIn(v: SignInValues): FieldErrors {
  const e: FieldErrors = {};
  if (!v.identifier.trim()) e.identifier = 'Username or email is required.';
  // No password length rule for sign-in — intentional (length is enforced only at sign-up).
  if (!v.password) e.password = 'Password is required.';
  return e;
}
